<template>

<div class="border-layout b">
  <div class="login-form p-fluid">
    <form @submit="alert()" action="/" method="post">
      <Card>
        <template #header>
          <div style="padding: 1em 1em 0 1em;">
            <h2>Еко МАГ склад</h2>
          </div>
        </template>
        <template #content>
          <div class="p-grid p-fluid">
            <div class="p-col-12 1p-md-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-user"></i>
                </span>
                <InputText placeholder="Потребител" v-model="user.user" @keyup.enter="onLogin()"/>
              </div>
            </div>
            <div class="p-col-12 1p-md-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-lock"></i>
                </span>
                <Password placeholder="Парола" v-model="user.password" :feedback="false" @keyup.enter="onLogin()"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <Button icon="pi pi-check" label="Вход" @click="onLogin" />
        </template>
      </Card>
    </form>
  <span style="color: white">Версия {{version}}</span>
  </div>
</div>

</template>

<script>

export default {
  emits: {
    login: null
  },

  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      user: {}
    }
  },

  methods: {
    onLogin() {
      this.$http.post('/authenticate', {
        user: this.user.user,
        password: this.user.password
      }).then((res) => {
        this.$emitter.emit('logged-in', res.data)
        this.$router.push('/')
      }).catch((res) => {
        this.$toast.add({
          severity: "error",
          summary: "Грешка при автентикация",
          detail: res.response.data,
          life: 2300
        });
      })
    },
  },

}

</script>

<style>
  .b {
    background: #296ad4;
  }
  .login-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 20em;
  }

</style>
